import { render, staticRenderFns } from "./TipTapImageComponent.vue?vue&type=template&id=6e2c6e7e&"
import script from "./TipTapImageComponent.vue?vue&type=script&lang=js&"
export * from "./TipTapImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./TipTapImageComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports